let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eO1Kc")).then(() => parcelRequire('9YXCZ'));